import { connect } from 'react-redux';
import { InstanceAPIs, Instances } from '../../../constants';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { IStateType } from '../../../store/models/root.interface';
import { removeObject } from '../../../store/Object';
import {
	changeFilters,
	clearFilters,
	updateObjects,
} from '../../../store/Objects';
import { closeSideBar, getParams } from '../../../store/sidebar';
import StickyAgentModal, {
	DispatchPropsType,
	MapStatePropsType,
} from '../organisms/StickyAgentModal';

const mapStateToProps = (state: IStateType) => {
	const params = getParams(state);
	return {
		params,
	};
};
const mapDispatchToProps = {
	onClose: () => {
		return closeSideBar([removeObject(Instances.StickyAgentModal)]);
	},

	onAddAgent: (data: any, cb: (res: any) => void) =>
		updateObjects(
			Instances.StickyAgents,
			'POST',
			data,
			undefined,
			undefined,
			undefined,
			undefined,
			undefined,
			cb,
			'',
			InstanceAPIs[Instances.StickyAgents].POST
		),

	onEdit: (data: any, callBack: any) =>
		updateObjects(
			Instances.StickyAgents,
			'PUT',
			data,
			undefined,
			{},
			'id',
			undefined,
			undefined,
			callBack,
			'',
			InstanceAPIs[Instances.StickyAgents].PUT
		),
	applyFilters: (filters: any) =>
		changeFilters(Instances.StickyAgents, filters),
	clearFilters: () => clearFilters(Instances.StickyAgents, '', {}),

};

export default connect<
	MapStatePropsType,
	DispatchPropsType,
	unknown,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(StickyAgentModal));
